/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum NursingInterventionsViewFragmentAliases {
  CONTEXTUAL_BAR_NURSING_INTERVENTATIONS = 'contextual-bar-nursing-interventations',
  FIELD_ADMINISTRATION = 'field-administration',
  FIELD_DURATION = 'field-duration',
  FIELD_END_DATE = 'field-end-date',
  FIELD_HOURS = 'field-hours',
  FIELD_INTERVAL_DESCRIPTION = 'field-interval-description',
  FIELD_INTERVENTION = 'field-Intervention',
  FIELD_NOW = 'field-now',
  FIELD_OBSERVATION = 'field-observation',
  FIELD_PRESCRIBER_DATE = 'field-prescriber-date',
  FIELD_PRESCRIBER_NAME = 'field-prescriber-name',
  FIELD_SIDE = 'field-side',
  FIELD_START_DATE = 'field-start-date',
  FIELD_TOPOGRAPHY = 'field-topography',
  FORM_ADDITIONAL_INFORMATION = 'form-additional-information',
  FORM_MAIN_INFORMATIONS = 'form-main-informations',
  FORM_PERIOD_OF_VALIDITY = 'form-period-of-validity',
  FRAGMENT_REFERENCE_NURSING_INTERVENTIONS = 'fragment-reference-nursing-interventions',
  INPUT_END_DATE = 'input-end-date',
  INPUT_NOW = 'input-now',
  INPUT_START_DATE = 'input-start-date',
  LAYOUT_NURSING_INTERVENTIONS = 'layout-nursing-interventions',
  LOADER = 'loader',
  PANEL_CONTENT = 'panel-content',
  PANEL_LOADER = 'panel-loader',
  SECTION_ADDITIONAL_INFORMATION = 'section-additional-information',
  SECTION_MAIN_INFORMATIONS = 'section-main-informations',
  SECTION_PERIOD_OF_VALIDITY = 'section-period-of-validity',
  SUPPRESS_HEADING_MARGIN_ADDITIONAL_INFORMATION = 'suppress-heading-margin-additional-information',
  SUPPRESS_HEADING_MARGIN_MAIN_INFORMATIONS = 'suppress-heading-margin-main-informations',
  SUPPRESS_HEADING_MARGIN_PERIOD_OF_VALIDITY = 'suppress-heading-margin-period-of-validity',
  TEXT_ADMINISTRATION = 'text-administration',
  TEXT_DURATION = 'text-duration',
  TEXT_HOURS = 'text-hours',
  TEXT_INTERVAL_DESCRIPTION = 'text-interval-description',
  TEXT_INTERVENTION = 'text-Intervention',
  TEXT_OBSERVATION = 'text-observation',
  TEXT_PRESCRIBER_DATE = 'text-prescriber-date',
  TEXT_PRESCRIBER_NAME = 'text-prescriber-name',
  TEXT_SIDE = 'text-side',
  TEXT_TOPOGRAPHY = 'text-topography',
}
export { NursingInterventionsViewFragmentAliases };
